<script>
import BaseFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';
import { WarehouseDevicesService } from '@/services/warehouse-devices.service';

export default {
  name: 'DeviceCodesFilter',

  extends: BaseFilter,

  data() {
    return {
      name: 'device_code'
    };
  },

  methods: {
    getData() {
      return WarehouseDevicesService.getFilteredDeviceCodes({
        search: this.search
      })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
